import React, { Component, Fragment } from 'react'
import { Translate } from '../../contexts/Language';
import { BreadCrumb, Card, Modal } from '../../components';
import { Config } from '../../config';
import { Service } from '../../services';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { ErrorMessage, ConfirmMessage, PortfolioMessage, Validator, VRules, VConditions } from '../../components/Validator';
import { data } from 'jquery';

export class erc20Wallet extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            dataTable: {
                columns: DataTableColumns.cryptoWalletERC20,
                rows: []
            },
            subListERC20 : {
                columns: DataTableColumns.subListERC20,
                rows: []
            },
            avaibleBalanceETH: 0,
            avaibleBalanceUSDT: 0,
            avaibleSubBalanceETH: 0,
            avaibleSubBalanceUSDT: 0,
            modal: false,
            erc20submodal: false,
            searchTerm: '',
            validation: {
                error: false,
                message: ""
            },
            validation2: {
                error: true,
                message: ""
            },
            validation3: {
                error: true,
                message: ""
            },
            formData: {
                address: "",
                amount: 0,
                comment: "",
                authCode: ""
            }
        }
        this.onSave = this.onSave.bind(this);
        this.dataTableRows = [];
    }
    componentDidMount() {
        this.onDatatable();
    }
    onDatatable() {
        Config.utilities.loadingFetch();

        Service.CryptoService.ListERC20().then(response => {

            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response.list;
                this.dataTableRows = response.list

                this.setState({
                    dataTable: dataTable,
                    avaibleBalanceETH: response.avaibleBalanceETH,
                    avaibleBalanceUSDT: response.avaibleBalanceUSDT
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    onListSub() {
        Config.utilities.loadingFetch();
        Service.CryptoService.ListSubERC20().then(response=> {
            if(response){
                this.setState(prevstate=>({ 

                        erc20submodal: true,
                        avaibleSubBalanceETH: response.avaibleSubBalanceETH,
                        avaibleSubBalanceUSDT: response.avaibleSubBalanceUSDT,
                        subListERC20:{
                        ...prevstate.subListERC20,
                        rows:response.subWalletsList
                    }
                 }))
            }
            Config.utilities.loadingFetch();
        })
    }
    onPortfolio() {
        Service.CryptoService.PortfolioERC20(0).then(response => {
            //0 göndermemizin nedeni portfoloio-manager için limiti kaldırmak 
            if (response) {
                this.setState({

                    validation3: response

                });
                if (!response.error) {
                    /* this.setState({
                         modal: false
                     })*/
                    this.onDatatable();
                }
            }
        });
    }

    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }
    onModal() {
        this.setState({
            modal: true
        });
    }
    isValid(data) {


        VRules["address"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Address can not be empty.")
        }
        VRules["comment"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Comment can not be empty.")
        }
        VRules["authCode"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Auth Code can not be empty.")
        }



        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error,
            validation2: error
        });

        return !error.error;
    }

    onSave() {
        if (this.isValid(this.state.formData)) {
            Config.utilities.loadingFetch();

            Service.CryptoService.CoinwithdrawERC20(this.state.formData).then(response => {

                if (response) {
                    this.setState({
                        validation: response,
                        validation2: response

                    });
                    if (!response.error) {
                        /* this.setState({
                             modal: false
                         })*/
                        this.onDatatable();
                    }
                }

                Config.utilities.loadingFetch();
            });
        }

    }
    onSearch(login) {

        let filteredRows = [];
        if (login === "") {
            filteredRows = this.dataTableRows;
        }
        else {
            filteredRows = this.dataTableRows.filter(item => item.login === login);
        }
        if (filteredRows.length > 0) {
            let dataTable = this.state.dataTable;
            dataTable.rows = filteredRows;
            this.setState({
                dataTable
            });
        }

    }

    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Wallet")} Name={Translate("Wallet")} />
                <PortfolioMessage Validation3={this.state.validation3} />
                <Card Title="ERC20 Main Wallet-0xD13BD467E69DDF5727Ab80Fc5Fb6df966900B165" Description="USDT (ERC20) Transaction History">
                {this.state.subListERC20 && <Modal
                        Title={"ERC20 Sub Wallet List"}
                        Show={this.state.erc20submodal}
                        onClose={(e) => this.setState({ erc20submodal: false })} 
                        xlSize 
                    >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="alert alert-success">
                                    <strong>Available SubBalance: </strong>
                                    <span>{this.state.avaibleSubBalanceETH} ETH</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="alert alert-warning">
                                    <strong>Available SubBalance: </strong>
                                    <span>{this.state.avaibleSubBalanceUSDT} USDT</span>
                                </div>
                            </div>
                        </div>
                        <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                        <input type="text" className="form-control col-md-2 mb-3" placeholder="Filter Login" onChange={(e) => this.setState({searchTerm: e.target.value})} />
                    {/* {console.log(this.state.subListERC20.rows.filter(e => e.login.toString().includes(this.state.searchTerm)))} */}
                         {!Array.isArray(this.state.subListERC20.rows) || this.state.subListERC20.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.subListERC20.columns}
                                    data={this.state.searchTerm.length > 0 ? this.state.subListERC20.rows.sort((a,b)=>+a.login - +b.login).filter(e => e.login.toString().includes(this.state.searchTerm)) : this.state.subListERC20.rows.sort((a,b)=>+a.login - +b.login)}
                                    pagination
                                    highlightOnHover />)}
                        </div>
                            </Modal>}
                    <Modal Title={Translate("USDT (ERC20) Withdrawal")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                        <div className="row mt-1 mb-1">
                            <p className="text-muted mb-2 ml-1 col-md-12 font-12">USDT (ERC20) Withdrawal</p>
                            <div className="col-md-12">
                                <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                    <ErrorMessage Validation={this.state.validation} />
                                    <ConfirmMessage Validation2={this.state.validation2} />
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Address</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="address" name="address" autoComplete="off" value={this.state.formData.address} onChange={(e) => this.onFormChange(e.target.value, "address")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Amount</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="number" id="amount" name="amount" autoComplete="off" value={this.state.formData.amount} onChange={(e) => this.onFormChange(e.target.value, "amount")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Comment</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="comment" name="comment" autoComplete="off" value={this.state.formData.comment} onChange={(e) => this.onFormChange(e.target.value, "comment")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">Google Auth. Code</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="authCode" name="authCode" autoComplete="off" value={this.state.formData.authCode} onChange={(e) => this.onFormChange(e.target.value, "authCode")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                        <div className="col-sm-8">
                                            <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> Save Form</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal>
                    <div className="row">

                        <div className="col-md-4">
                            <div class="alert alert-success">
                                <strong>Avaible Balance: </strong>
                                <span>{this.state.avaibleBalanceETH} ETH</span>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div class="alert alert-warning">
                                <strong>Avaible Balance: </strong>
                                <span>{this.state.avaibleBalanceUSDT} USDT</span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className=" d-flex justify-content-end">
                                <button type="button" className="btn btn-success add-new-button tabless ml-1" onClick={() => this.onListSub()} ><i className="fas fa-coins mr-3" ></i>ERC20 Sub Wallet List</button>
                                <button type="button" className="btn btn-danger  add-new-button tabless ml-1" onClick={(e) => this.onModal()}><i className="fas fa-coins mr-1"></i> USDT (ERC20) Withdrawal</button>
                                <button type="button" className="btn btn-dark  add-new-button tabless ml-1" onClick={(e) => this.onPortfolio()}><i className="fas fa-coins mr-1"></i> ERC20 Manuel Tetikleme </button>

                            </div>

                            <input type="text" className="form-control col-md-2 mb-3" placeholder="Filter Login" onChange={(e) => this.onSearch(e.target.value)} />


                            {!Array.isArray(this.state.dataTable.rows) || this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.dataTable.columns}
                                    data={this.state.dataTable.rows}
                                    pagination
                                    highlightOnHover />)}
                        </div>
                    </div>
                </Card>
            </Fragment>)
    }
}